import { cva } from "cva";

export const primaryButtonStyle = cva(
  [
    "whitespace-nowrap rounded-md px-3.5 py-2.5 font-semibold leading-none shadow-1 hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
  ],
  {
    defaultVariants: {
      appearance: "light",
    },
    variants: {
      appearance: {
        brand: "bg-white text-brand-indigo-600",
        dark: "bg-white text-gray-900 focus-visible:outline-white",
        light:
          "bg-brand-indigo-600 text-white focus-visible:outline-brand-indigo-600",
      },
      disabled: {
        true: "opacity-40",
        false: "",
      },
    },
    compoundVariants: [
      {
        appearance: "brand",
        disabled: false,
        className: "hover:bg-brand-indigo-100",
      },
      {
        appearance: "dark",
        disabled: false,
        className: "hover:bg-gray-100",
      },
      {
        appearance: "light",
        disabled: false,
        className: "hover:bg-brand-indigo-500",
      },
    ],
  }
);

export const secondaryButtonStyle = cva(["font-semibold"], {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-white",
      dark: "text-white",
      light: "text-gray-900",
    },
  },
});
